<template>
  <div class="project-status f12 fw500" :class="status">
    {{ status !== 'test' ? statusText : '-' }}
  </div>
</template>

<script>
export default {
  name: 'ProjectCard',
  props: {
    status: String,
  },
  data() {
    return {}
  },
  computed: {
    statusText() {
      return this.status == 'creating'
        ? this.localStorage.translations.pages.projects_status.status['predvaritelnyy'] || ''
        : this.status == 'intro'
        ? this.localStorage.translations.pages.projects_status.status['beginer'] || ''
        : this.status == 'bidding'
        ? this.localStorage.translations.pages.projects_status.status['tsenopredlozhenie'] || ''
        : this.status == 'canceled'
        ? this.localStorage.translations.pages.projects_status.status['ne-sostoyavshiysya'] || ''
        : this.status == 'pending'
        ? this.localStorage.translations.pages.projects_status.status['v-ozhidanii'] || ''
        : this.status == 'in_progress'
        ? this.localStorage.translations.pages.projects_status.status['v-rabote'] || ''
        : this.status == 'done'
        ? this.localStorage.translations.pages.projects_status.status['zavershen'] || ''
        : null
    },
  },
}
</script>

<style lang="scss" scoped>
.project-status {
  background: #888888;
  border-radius: 4px;
  padding: 4px 8px;
  line-height: 148%;
  color: #ffffff;
  width: max-content;
  height: max-content;
  justify-self: center;
  &.creating {
    background: #008deb;
  }
  &.bidding {
    background: #f2a127;
  }
  &.pending {
    background: #ffeb3b;
    color: #000;
  }
  &.in_progress {
    background: #26bc2c;
  }
}
</style>
